import { render, staticRenderFns } from "./TemplateManager.vue?vue&type=template&id=2d594475&"
import script from "./TemplateManager.vue?vue&type=script&lang=js&"
export * from "./TemplateManager.vue?vue&type=script&lang=js&"
import style0 from "./TemplateManager.vue?vue&type=style&index=0&id=2d594475&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports